import { SalesChannelCampaignRulesPage } from "@/features/sales-channel-campaign/pages/SalesChannelCampaignRulesPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/sales-channel-campaign/rules")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({ permissions: ["marketplace_campaigns.view"] })
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: SalesChannelCampaignRulesPage,
});